import "./SignIn.css";

import { useData } from "../../consts";
import SvgPerson from "../../assets/images/person.svg";

export default function SignIn(){
  const {loggedIn, setLoggedIn, userInfo, setUserInfo} = useData();
  return loggedIn?<li className="nav-item dropdown">
      <a className="nav-link dropdown-toggle pull-left"
          role="button" aria-current="page" href="#"
          data-bs-toggle="dropdown" aria-expanded="false"
      > <img className="" src={SvgPerson} style={{"width":"1.5em"}} /> {userInfo.user_name} </a>

<ul className="dropdown-menu form-menu">
          <li>
              <div
                className="container"
              >
                <form className="px-4 py-3">
                  <div className="mb-3">
                    <label htmlFor="exampleDropdownFormEmail1" className="form-label">Email address</label>
                    <input type="email" className="form-control" id="exampleDropdownFormEmail1" placeholder="email@example.com" />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleDropdownFormPassword1" className="form-label">Password</label>
                    <input type="password" className="form-control" id="exampleDropdownFormPassword1" placeholder="Password" />
                  </div>
                  <div className="mb-3">
                    <div className="form-check">
                      <input type="checkbox" className="form-check-input" id="dropdownCheck" />
                      <label className="form-check-label" htmlFor="dropdownCheck">
                        Remember me
                      </label>
                    </div>
                  </div>
                  <button type="button" className="btn btn-primary"
                    onClick={evt=>{
                      setLoggedIn(false);
                      setUserInfo(false);
                    }}
                  >log out</button>
                </form>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item" href="#">New around here? Sign up</a>
                <a className="dropdown-item" href="#">Forgot password?</a>
              </div>;
          </li>
      </ul>

  </li>
  :<li className="nav-item dropdown">
      <a className="nav-link dropdown-toggle pull-left"
          role="button" aria-current="page" href="#"
          data-bs-toggle="dropdown" aria-expanded="false"
      > <img className="" src={SvgPerson} style={{"width":"1.5em"}} /> Sign in</a>
      <ul className="dropdown-menu form-menu">
          <li>
              <div
                className="container"
              >
                <form className="px-4 py-3">
                  <div className="mb-3">
                    <label htmlFor="exampleDropdownFormEmail1" className="form-label">Email address</label>
                    <input type="email" className="form-control" id="exampleDropdownFormEmail1" placeholder="email@example.com" />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleDropdownFormPassword1" className="form-label">Password</label>
                    <input type="password" className="form-control" id="exampleDropdownFormPassword1" placeholder="Password" />
                  </div>
                  <div className="mb-3">
                    <div className="form-check">
                      <input type="checkbox" className="form-check-input" id="dropdownCheck" />
                      <label className="form-check-label" htmlFor="dropdownCheck">
                        Remember me
                      </label>
                    </div>
                  </div>
                  <button type="button" className="btn btn-primary"
                    onClick={evt=>{
                      setLoggedIn(true);
                      setUserInfo({
                        user_name: 'test user'
                      });
                    }}
                  >Sign in</button>
                </form>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item" href="#">New around here? Sign up</a>
                <a className="dropdown-item" href="#">Forgot password?</a>
              </div>;
          </li>
      </ul>
  </li>
  

}